import { useState, useEffect } from 'react';
import './TypeWriter.css';

const TypeWriter = ({ 
  text, 
  speed = 80, 
  delay = 0, 
  className = '',
  onComplete = () => {} 
}) => {
  const [displayText, setDisplayText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isComplete, setIsComplete] = useState(false);
  const [showCursor, setShowCursor] = useState(true);

  useEffect(() => {
    if (currentIndex < text.length) {
      const timer = setTimeout(() => {
        setDisplayText(prev => prev + text[currentIndex]);
        setCurrentIndex(prev => prev + 1);
      }, currentIndex === 0 ? delay : speed);

      return () => clearTimeout(timer);
    } else if (!isComplete) {
      setIsComplete(true);
      // 完成后延迟隐藏光标
      setTimeout(() => setShowCursor(false), 1000);
      onComplete();
    }
  }, [currentIndex, text, speed, delay, isComplete, onComplete]);

  return (
    <span className={`typewriter-container ${className}`}>
      {displayText}
      {showCursor && <span className="cursor">_</span>}
    </span>
  );
};

const AnimatedText = ({ 
  title, 
  subtitle, 
  titleSpeed = 80, 
  subtitleSpeed = 60,
  titleDelay = 500,
  subtitleDelay = 300,
  onAnimationComplete = () => {}
}) => {
  const [showSubtitle, setShowSubtitle] = useState(false);

  const handleTitleComplete = () => {
    setTimeout(() => setShowSubtitle(true), subtitleDelay);
  };

  const handleSubtitleComplete = () => {
    setTimeout(() => {
      onAnimationComplete();
    }, 800);
  };

  return (
    <div className="animated-text-container">
      <h1 className="animated-title">
        <TypeWriter 
          text={title}
          speed={titleSpeed}
          delay={titleDelay}
          onComplete={handleTitleComplete}
        />
      </h1>
      {showSubtitle && (
        <p className="animated-subtitle text-reveal">
          <TypeWriter 
            text={subtitle}
            speed={subtitleSpeed}
            delay={0}
            onComplete={handleSubtitleComplete}
          />
        </p>
      )}
    </div>
  );
};

export default AnimatedText;